import PlateTypeService from 'business/services/PlateTypeService';
import { useEffect, useState } from 'react';

export const usePlateTypes = () => {
  const [originalPlateTypes, setOriginalPlateTypes] = useState([]);
  const [currentPlateTypes, setCurrentPlateTypes] = useState([]);
  const [previousDropNums, setPreviousDropNums] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      const plateTypeService = new PlateTypeService();
      return plateTypeService.getAllPlateTypes();
    };
    fetchData().then((plateTypes) => {
      setCurrentPlateTypes(plateTypes.saveContainerDTOs);
      setOriginalPlateTypes(plateTypes.saveContainerDTOs);
      setPreviousDropNums(
        plateTypes.saveContainerDTOs.map((plateType) => plateType.maxNumDrops),
      );
    });
  }, []);
  return {
    originalPlateTypes,
    setOriginalPlateTypes,
    currentPlateTypes,
    setCurrentPlateTypes,
    previousDropNums,
    setPreviousDropNums,
  };
};
